<template>
  <div class="card card-custom card-stretch gutter-b setting-item">
    <!--begin::Header-->
    <div class="card-header align-items-center">
      <h3 class="card-title align-items-start flex-column">
        <span class="title font-weight-bold">
          {{ i18n.uv }}
        </span>
      </h3>
      <div class="card-toolbar toolbar-symbol">
        <a href="#" class="btn btn-icon btn-hover-light-primary draggable-handle">
          <i class="ki ki-menu"></i>
        </a>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body">
      <!--begin::form-group-->
      <div class="form-group row">
        <label class="col-form-label col-12 col-lg-6">
          <span class="font-weight-normal">{{ i18n.startTime }}</span>
        </label>
        <div class="col-12 col-lg-6">
          <b-form-timepicker v-if="this.controllerType == '제닉스'" v-model="uvStarttimeHm" size="sm" locale="en-us" class="mb-2 genix" minutes-step="60" @input="conveyTime"></b-form-timepicker>
          <b-form-timepicker v-else v-model="uvStarttimeHm" size="sm" locale="en-us" class="mb-2" @input="conveyTime"></b-form-timepicker>
        </div>
      </div>
      <!--end::form-group-->
      <!--begin::form-group-->
      <div class="form-group row">
        <label class="col-form-label col-12">
          <span class="font-weight-normal">{{ i18n.operationTime }} : {{uvDurationHh}}{{i18n.hour}}</span>
        </label>
        <div class="col-12">
          <template>
            <div class="custom-range-slider">
              <b-form-input id="range-2" v-model="uvDurationHh" type="range" min="0" max="24" step="1" @change="conveyData('uvDurationHh')"></b-form-input>
              <div class=" d-flex justify-content-between">
                <span class="text">0</span>
                <span class="text">3</span>
                <span class="text">6</span>
                <span class="text">9</span>
                <span class="text">12</span>
                <span class="text">15</span>
                <span class="text">18</span>
                <span class="text">21</span>
                <span class="text">24</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!--end::form-group-->
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import i18n from '@/core/plugins/vue-i18n.js';

export default {
  name: "Setting10",
  props: {
    elementObj: Object,
    mutateValue: Function,
    effectValue: Number,
    controllerType: String
  },
  watch: {
    effectValue(){
      if(this.elementObj) {
        this.uvDurationHh = this.elementObj.uvDurationHh
        if(this.elementObj.uvStarttimeHh !== undefined || this.elementObj.uvStarttimeMm !== undefined) {
          this.uvStarttimeHm = [(this.elementObj.uvStarttimeHh || '00'), (this.elementObj.uvStarttimeMm || '00'), '00'].join(':');
        }else{
          this.uvStarttimeHm = '';
        }
      }
    }
  },
  data() {
    return {
      uvStarttimeHm : '',
      uvDurationHh : 0,
      i18n: {
        uv: i18n.t('cultivationEnvControlSetting.uv'),
        startTime: i18n.t('cultivationEnvControlSetting.startTime'),
        operationTime: i18n.t('cultivationEnvControlSetting.operationTime'),
        hour: i18n.t('cultivationEnvControlSetting.hour')
      }
    }
  },
  methods: {
    conveyTime(){
      if(this.uvStarttimeHm){
        const starttimeList = this.uvStarttimeHm.split(':');
        if(starttimeList && starttimeList.length === 3) {
          this.mutateValue('uv', 'uvStarttimeHh', starttimeList[0]);
          this.mutateValue('uv', 'uvStarttimeMm', starttimeList[1]);
        }
      }
    },
    conveyData(key){
      this.mutateValue('uv', key, this[key]);
    },
  }
};
</script>
